import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  ArrowRight, CalendarDays, ChevronLeft, ChevronRight, ClipboardList, Crown, ExternalLink,
  GraduationCap, HeartHandshake, Home, Megaphone, MessageCircle, Newspaper, Paperclip, ShieldCheck,
  Sparkles, Trophy, UserRound, Users, Lightbulb, Rocket, Store, Palette, Music2,
  Flag, Globe2, Building2, BarChart3, Laptop2, ShipWheel, Plane, Bot,
  BatteryCharging, Atom, Calculator, Database,
} from 'lucide-react';
import SEO from '../components/SEO';
import {
  fetchDosenByIdentifier, fetchPengumumanUnit, fetchUnitAnggota, fetchUnitMemberProfile,
  formatTanggalIndonesia, getImageUrl,
} from '../utils/api';

const UNIT = 'kemahasiswaan';
const ANNOUNCEMENTS_PER_PAGE = 4;

// Kartu pimpinan cadangan — dipakai bila belum ada anggota unit ber-"Kepala Unit"
// yang dikelola dari panel admin Struktur Unit.
const HEAD_FALLBACK = {
  name: 'Ahmad Husaini, SKM., M.Kes.',
  position: 'Ka. Unit Kemahasiswaan & Alumni',
  slug: 'ahmad-husaini-skm-m-kes',
  photoId: '07ff711f-66be-4f96-8f01-84817230eefb',
};

const services = [
  {
    icon: Users,
    title: 'Pembinaan Organisasi Kemahasiswaan',
    description: 'Pendampingan BEM, Himpunan Mahasiswa Program Studi, dan Unit Kegiatan Mahasiswa dalam berorganisasi.',
  },
  {
    icon: Trophy,
    title: 'Penalaran, Minat & Bakat',
    description: 'Fasilitasi Program Kreativitas Mahasiswa (PKM), lomba, dan kompetisi untuk mendorong prestasi mahasiswa.',
  },
  {
    icon: HeartHandshake,
    title: 'Kesejahteraan & Bimbingan Mahasiswa',
    description: 'Layanan beasiswa non-akademik, bimbingan konseling, dan advokasi kesejahteraan mahasiswa.',
  },
  {
    icon: ClipboardList,
    title: 'Layanan Kegiatan & Perizinan',
    description: 'Pengurusan proposal kegiatan, dispensasi, surat tugas, dan administrasi kegiatan kemahasiswaan.',
  },
  {
    icon: ShieldCheck,
    title: 'Pembinaan Karakter & Kedisiplinan',
    description: 'Penguatan etika, tata tertib, dan pembinaan karakter mahasiswa sesuai nilai almamater.',
  },
  {
    icon: Sparkles,
    title: 'Pemberdayaan & Jejaring Alumni',
    description: 'Pengelolaan Ikatan Alumni STIKES HI, temu alumni, dan pelibatan alumni dalam pengembangan kampus.',
  },
];

const SIMBELMAWA_PORTAL_URL = 'https://simbelmawa.kemdiktisaintek.go.id/portal/';

const simbelmawaPrograms = [
  { title: 'PKM', description: 'Program Kreativitas Mahasiswa', icon: Lightbulb, url: 'https://simbelmawa.kemdiktisaintek.go.id/pkm' },
  { title: 'PIMNAS', description: 'Pekan Ilmiah Mahasiswa Nasional', icon: Trophy, url: 'https://simbelmawa.kemdiktisaintek.go.id/pkm' },
  { title: 'P2MW', description: 'Pembinaan Mahasiswa Wirausaha', icon: Rocket, url: 'https://p2mw.kemdiktisaintek.go.id/' },
  { title: 'KMI Expo', description: 'Kewirausahaan Mahasiswa Indonesia', icon: Store, url: 'https://p2mw.kemdiktisaintek.go.id/' },
  { title: 'PPK Ormawa', description: 'Penguatan Kapasitas Organisasi Kemahasiswaan', icon: Users, url: 'https://ppkormawa.kemdiktisaintek.go.id/' },
  { title: 'Abdidaya Ormawa', description: 'Apresiasi kegiatan pengabdian Ormawa', icon: HeartHandshake, url: 'https://ppkormawa.kemdiktisaintek.go.id/' },
  { title: 'Peksiminas', description: 'Pekan Seni Mahasiswa Nasional', icon: Palette, url: 'https://simbelmawa.kemdiktisaintek.go.id/peksiminas' },
  { title: 'Pesparawi', description: 'Pesta Paduan Suara Gerejawi', icon: Music2, url: 'https://simbelmawa.kemdiktisaintek.go.id/' },
  { title: 'Pilmapres', description: 'Pemilihan Mahasiswa Berprestasi', icon: GraduationCap, url: 'https://simbelmawa.kemdiktisaintek.go.id/pilmapres' },
  { title: 'AUG', description: 'ASEAN University Games', icon: Globe2, url: 'https://www.aug2026.my/index.php/en/' },
  { title: 'KJI', description: 'Kompetisi Jembatan Indonesia', icon: ShipWheel, url: 'https://kjikbgi.kemdiktisaintek.go.id/' },
  { title: 'KBGI', description: 'Kompetisi Bangunan Gedung Indonesia', icon: Building2, url: 'https://kjikbgi.kemdiktisaintek.go.id/' },
  { title: 'KBMK', description: 'Kompetisi Bisnis Mahasiswa Indonesia', icon: BarChart3, url: 'https://kbmk.kemdiktisaintek.go.id/' },
  { title: 'LIDM', description: 'Lomba Inovasi Digital Mahasiswa', icon: Laptop2, url: 'https://simbelmawa.kemdiktisaintek.go.id' },
  { title: 'KKI', description: 'Kompetisi Konstruksi Indonesia', icon: Flag, url: 'https://kompetisicerdas.kemdiktisaintek.go.id/' },
  { title: 'KRTI', description: 'Kontes Robot Terbang Indonesia', icon: Plane, url: 'https://kompetisicerdas.kemdiktisaintek.go.id/' },
  { title: 'KAI', description: 'Kontes Robot Abu Indonesia', icon: Bot, url: 'https://kompetisicerdas.kemdiktisaintek.go.id/' },
  { title: 'KMHE', description: 'Kontes Mobil Hemat Energi', icon: BatteryCharging, url: 'https://kmhe.kemdiktisaintek.go.id/' },
  { title: 'GEMASTIK', description: 'Pagelaran Mahasiswa Nasional Bidang Teknologi Informasi dan Komunikasi', icon: Atom, url: 'https://kompetisicerdas.kemdiktisaintek.go.id/' },
  { title: 'ON-MIPA', description: 'Olimpiade Nasional Matematika dan Ilmu Pengetahuan Alam', icon: Calculator, url: 'https://kompetisicerdas.kemdiktisaintek.go.id/' },
  { title: 'Satria Data', description: 'Statistika Ria dan Festival Sains Data', icon: Database, url: 'https://kompetisicerdas.kemdiktisaintek.go.id/' },
];

/// Menarik foto profil anggota unit sekaligus menentukan jenis tautan profil.
function useProfilePhoto(slug, profileType, { width = 240, height = 300 } = {}) {
  const [photo, setPhoto] = useState(null);
  const [linkPath, setLinkPath] = useState(null);

  useEffect(() => {
    if (!slug) return undefined;
    let active = true;
    (async () => {
      try {
        const result = await fetchUnitMemberProfile(slug, profileType);
        if (active && result) {
          setLinkPath(`/${result.kind}/${slug}`);
          if (result.profile.foto) setPhoto(getImageUrl(result.profile.foto, { width, height, quality: 85 }));
        }
      } catch {
        // Biarkan tanpa foto; kartu tetap tampil dengan inisial.
      }
    })();
    return () => { active = false; };
  }, [slug, profileType, width, height]);

  return { photo, linkPath };
}

function MemberCard({ member }) {
  const { photo, linkPath } = useProfilePhoto(member.profileSlug, member.profileType, { width: 240, height: 300 });
  const initials = member.name.split(/\s+/).slice(0, 2).map((p) => p[0]).join('').toUpperCase();

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4 }}
      className={`rounded-2xl border bg-white p-6 shadow-sm transition hover:shadow-lg dark:bg-[#1A182E] ${
        member.isHead
          ? 'border-amber-300 border-l-4 border-l-amber-500 dark:border-amber-400/30 dark:border-l-amber-400'
          : 'border-gray-100 dark:border-gray-800'
      }`}
    >
      <div className="flex items-start gap-4">
        <div className="grid h-20 w-16 flex-shrink-0 place-items-center overflow-hidden rounded-xl bg-purple-50 dark:bg-purple-900/30">
          {photo
            ? <img src={photo} alt={member.name} loading="lazy" className="h-full w-full object-cover" />
            : <span className="text-lg font-bold text-[#7B2FBE]">{initials}</span>}
        </div>
        <div className="min-w-0 flex-1">
          {member.isHead && (
            <span className="mb-1.5 inline-flex items-center gap-1 rounded-full border border-amber-300 bg-amber-400 px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-wide text-amber-950 shadow-sm dark:border-amber-300/40 dark:bg-amber-300 dark:text-amber-950">
              <Crown size={10} /> Kepala Unit
            </span>
          )}
          <h3 className="font-heading text-sm font-bold leading-tight text-[#1A1A2E] dark:text-white">{member.name}</h3>
          <p className="mt-0.5 text-xs text-[#7B2FBE] dark:text-purple-300">{member.position}</p>
          {member.whatsapp && (
            <a
              href={`https://wa.me/${member.whatsapp}`}
              target="_blank"
              rel="noreferrer"
              className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold text-emerald-600 transition hover:text-emerald-700 hover:underline dark:text-emerald-400 dark:hover:text-emerald-300"
            >
              <MessageCircle size={13} /> Hubungi via WhatsApp
            </a>
          )}
          {member.tasks?.length > 0 && (
            <ul className="mt-3 space-y-1.5">
              {member.tasks.map((task, i) => (
                <li key={i} className="flex items-start gap-2 text-xs text-gray-600 dark:text-gray-400">
                  <ArrowRight size={12} className="mt-0.5 flex-shrink-0 text-[#7B2FBE]" />
                  {task}
                </li>
              ))}
            </ul>
          )}
          {linkPath && member.profileSlug && (
            <Link to={linkPath} className="mt-3 inline-flex items-center gap-1.5 text-xs text-[#7B2FBE] hover:underline">
              <UserRound size={12} /> Lihat profil
            </Link>
          )}
        </div>
      </div>
    </motion.div>
  );
}

function AnnouncementCard({ item }) {
  const thumbUrl = getImageUrl(item.thumbnail, { width: 640, height: 320 });
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4 }}
      className="overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-sm transition hover:shadow-lg dark:border-gray-800 dark:bg-[#1A182E]"
    >
      {thumbUrl && (
        <Link to={`/berita/${item.slug}`} className="block h-40 overflow-hidden">
          <img
            src={thumbUrl}
            alt={item.judul}
            loading="lazy"
            style={{ objectPosition: item.thumbnailPosition || '50% 50%' }}
            className="h-full w-full object-cover transition-transform duration-300 hover:scale-105"
          />
        </Link>
      )}
      <div className="p-6">
        <div className="mb-2 flex items-center gap-2 text-xs text-gray-400 dark:text-gray-500">
          <CalendarDays size={12} /> {formatTanggalIndonesia(item.tanggal_publikasi)}
        </div>
        <Link to={`/berita/${item.slug}`} className="group block">
          <h3 className="font-heading text-sm font-bold leading-snug text-[#1A1A2E] transition-colors group-hover:text-[#7B2FBE] dark:text-white">
            {item.judul}
          </h3>
        </Link>
        {item.Excerpt && (
          <p className="mt-2 line-clamp-3 text-xs leading-relaxed text-gray-600 dark:text-gray-400">{item.Excerpt}</p>
        )}
        <div className="mt-4 flex flex-wrap items-center gap-3 border-t border-gray-100 pt-3 dark:border-gray-800">
          <Link to={`/berita/${item.slug}`} className="inline-flex items-center gap-1.5 text-xs font-medium text-[#7B2FBE] hover:underline">
            Baca selengkapnya <ArrowRight size={12} />
          </Link>
          {item.lampiranUrl && (
            <a href={item.lampiranUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 text-xs text-gray-500 hover:text-[#7B2FBE] dark:text-gray-400">
              <Paperclip size={12} /> {item.lampiranNama || 'Lampiran'}
            </a>
          )}
          {item.tautan && (
            <a href={item.tautan} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 text-xs text-gray-500 hover:text-[#7B2FBE] dark:text-gray-400">
              <ExternalLink size={12} /> Tautan terkait
            </a>
          )}
        </div>
      </div>
    </motion.div>
  );
}

const Kemahasiswaan = () => {
  const [members, setMembers] = useState([]);
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [headProfile, setHeadProfile] = useState(HEAD_FALLBACK);
  const [announcementPage, setAnnouncementPage] = useState(1);

  const headMember = members.find((m) => m.isHead) || null;
  const otherMembers = members.filter((m) => !m.isHead);
  const announcementTotalPages = Math.max(1, Math.ceil(announcements.length / ANNOUNCEMENTS_PER_PAGE));
  const currentAnnouncementPage = Math.min(announcementPage, announcementTotalPages);
  const pageAnnouncements = announcements.slice(
    (currentAnnouncementPage - 1) * ANNOUNCEMENTS_PER_PAGE,
    currentAnnouncementPage * ANNOUNCEMENTS_PER_PAGE,
  );

  useEffect(() => {
    let active = true;

    Promise.all([
      fetchUnitAnggota(UNIT).catch(() => []),
      fetchPengumumanUnit(UNIT).catch(() => []),
    ]).then(([memberData, announcementData]) => {
      if (!active) return;
      setMembers(Array.isArray(memberData) ? memberData : []);
      setAnnouncements(Array.isArray(announcementData) ? announcementData : []);
      setAnnouncementPage(1);
      setLoading(false);
    });

    fetchDosenByIdentifier(HEAD_FALLBACK.slug)
      .then((dosen) => {
        if (!active || !dosen) return;
        setHeadProfile((cur) => ({
          ...cur,
          name: dosen.nama || cur.name,
          slug: dosen.slug || cur.slug,
          photoId: dosen.foto || cur.photoId,
        }));
      })
      .catch(() => {});

    return () => { active = false; };
  }, []);

  const headName = headMember?.name || headProfile.name;
  const headPosition = headMember?.position || headProfile.position;
  const headWhatsapp = headMember?.whatsapp || null;
  const headTasks = headMember?.tasks || [];
  const headSlug = headMember?.profileSlug || headProfile.slug;
  const headPhoto = headMember
    ? null
    : (headProfile.photoId ? getImageUrl(headProfile.photoId, { width: 720, height: 900, quality: 88 }) : null);
  const fallbackHeadPhoto = useProfilePhoto(headMember?.profileSlug, headMember?.profileType, { width: 720, height: 900 });
  const resolvedHeadPhoto = headPhoto || fallbackHeadPhoto.photo;
  const headLink = headMember ? (fallbackHeadPhoto.linkPath || `/${headMember.profileType || 'tendik'}/${headSlug}`) : `/dosen/${headSlug}`;

  return (
  <div data-testid="kemahasiswaan-page">
    <SEO
      title="Kemahasiswaan & Alumni"
      description="Unit Kemahasiswaan & Alumni STIKES Harapan Ibu Jambi — pembinaan organisasi mahasiswa, penalaran & prestasi, kesejahteraan mahasiswa, pembinaan karakter, dan jejaring alumni."
      image={resolvedHeadPhoto}
    />

    <div className="page-hero pt-[70px]">
      <div className="relative z-10 mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <div className="mb-4 flex flex-wrap items-center gap-2 text-sm text-white/70">
            <Link to="/" className="flex items-center gap-1 transition-colors hover:text-white">
              <Home size={14} /> Beranda
            </Link>
            <ChevronRight size={14} />
            <span>Unit</span>
            <ChevronRight size={14} />
            <span className="text-white">Kemahasiswaan &amp; Alumni</span>
          </div>
          <h1 className="font-heading text-4xl font-bold text-white md:text-5xl">Kemahasiswaan &amp; Alumni</h1>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-white/80">
            Membina pengembangan diri, penalaran, minat dan bakat, serta kesejahteraan mahasiswa STIKES Harapan
            Ibu Jambi, sekaligus merawat jejaring dan pemberdayaan alumni.
          </p>
        </motion.div>
      </div>
    </div>

    <main className="bg-[#F8F7FF] dark:bg-[#121020]">
      {/* Tentang & Pimpinan */}
      <section className="py-16">
        <div className="mx-auto grid max-w-6xl gap-8 px-4 sm:px-6 lg:grid-cols-[360px_minmax(0,1fr)] lg:px-8">
          <motion.article
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="overflow-hidden rounded-3xl border border-purple-100 bg-white shadow-sm dark:border-purple-900/30 dark:bg-[#1A182E]"
          >
            <div className="relative aspect-[4/5] overflow-hidden bg-purple-100 dark:bg-purple-950/30">
              {resolvedHeadPhoto ? (
                <img src={resolvedHeadPhoto} alt={headName} className="h-full w-full object-cover object-top" />
              ) : (
                <div className="grid h-full w-full place-items-center bg-gradient-to-br from-[#7B2FBE] to-[#4C1D95] text-6xl font-bold text-white">
                  {headName.split(' ').filter(Boolean).slice(0, 2).map((w) => w[0]).join('')}
                </div>
              )}
              <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-[#171128]/90 to-transparent" />
              <span className="absolute bottom-4 left-4 inline-flex items-center gap-1.5 rounded-full border border-amber-200 bg-amber-400 px-3 py-1.5 text-xs font-extrabold text-amber-950 shadow-lg shadow-black/20">
                <Crown size={13} /> Kepala Unit
              </span>
            </div>
            <div className="p-6">
              <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#7B2FBE] dark:text-purple-300">
                Pimpinan Unit
              </p>
              <h2 className="mt-2 font-heading text-xl font-bold leading-snug text-[#1A1A2E] dark:text-white">
                {headName}
              </h2>
              <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">{headPosition}</p>
              {headWhatsapp && (
                <a
                  href={`https://wa.me/${headWhatsapp}`}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold text-emerald-600 transition hover:text-emerald-700 hover:underline dark:text-emerald-400 dark:hover:text-emerald-300"
                >
                  <MessageCircle size={13} /> Hubungi via WhatsApp
                </a>
              )}
              {headTasks.length > 0 && (
                <ul className="mt-3 space-y-1.5">
                  {headTasks.map((task, i) => (
                    <li key={i} className="flex items-start gap-2 text-xs text-gray-600 dark:text-gray-400">
                      <ArrowRight size={12} className="mt-0.5 flex-shrink-0 text-[#7B2FBE]" />
                      {task}
                    </li>
                  ))}
                </ul>
              )}
              {headSlug && (
                <Link
                  to={headLink}
                  className="mt-5 inline-flex items-center gap-2 rounded-xl border border-purple-200 px-4 py-2.5 text-sm font-semibold text-[#7B2FBE] transition hover:border-[#7B2FBE] hover:bg-purple-50 dark:border-purple-800 dark:text-purple-300 dark:hover:bg-purple-900/20"
                >
                  Lihat Profil <ArrowRight size={16} />
                </Link>
              )}
            </div>
          </motion.article>

          <div className="flex flex-col justify-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
            >
              <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#7B2FBE] dark:text-purple-300">
                Unit &amp; Lembaga
              </span>
              <h2 className="mt-3 font-heading text-3xl font-bold text-[#1A1A2E] dark:text-white">
                Unit Kemahasiswaan &amp; Alumni
              </h2>
              <p className="mt-5 leading-relaxed text-gray-600 dark:text-gray-300">
                Unit Kemahasiswaan &amp; Alumni membina kegiatan dan pengembangan diri mahasiswa STIKES Harapan
                Ibu Jambi — mulai dari organisasi kemahasiswaan, penalaran, minat dan bakat, hingga kesejahteraan
                dan pembinaan karakter.
              </p>
              <p className="mt-4 leading-relaxed text-gray-600 dark:text-gray-300">
                Unit ini juga menjadi penghubung kampus dengan para alumni melalui Ikatan Alumni STIKES HI,
                kegiatan temu alumni, serta pelibatan alumni dalam pengembangan almamater.
              </p>
            </motion.div>

            <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
              {services.map(({ icon: Icon, title, description }, index) => (
                <motion.div
                  key={title}
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.12 + index * 0.06 }}
                  className="rounded-2xl border border-purple-100 bg-white p-5 dark:border-purple-900/30 dark:bg-[#1A182E]"
                >
                  <span className="grid h-10 w-10 place-items-center rounded-xl bg-purple-100 text-[#7B2FBE] dark:bg-purple-900/30 dark:text-purple-300">
                    <Icon size={19} />
                  </span>
                  <h3 className="mt-4 font-heading text-sm font-bold text-[#1A1A2E] dark:text-white">{title}</h3>
                  <p className="mt-2 text-xs leading-relaxed text-gray-500 dark:text-gray-400">{description}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Anggota unit (tampil bila sudah dikelola dari admin) */}
      {otherMembers.length > 0 && (
        <section className="bg-white py-16 dark:bg-[#100E1C]">
          <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
            <h2 className="font-heading text-2xl font-bold text-[#1A1A2E] dark:text-white">Tim &amp; Anggota Unit</h2>
            <p className="mt-1.5 text-sm text-gray-500 dark:text-gray-400">
              Staf Unit Kemahasiswaan &amp; Alumni beserta bidang tugas masing-masing.
            </p>
            <div className="mt-6 grid gap-5 lg:grid-cols-2">
              {otherMembers.map((member) => <MemberCard key={member.id} member={member} />)}
            </div>
          </div>
        </section>
      )}

      {/* Pengumuman unit — dikelola dari panel admin (menu Pengumuman, unit Kemahasiswaan & Alumni) */}
       <section className={`hidden py-16 ${otherMembers.length > 0 ? 'bg-[#F8F7FF] dark:bg-[#121020]' : 'bg-white dark:bg-[#100E1C]'}`}>
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
          <div className="mb-6 flex items-end justify-between gap-4">
            <div>
              <h2 className="font-heading text-2xl font-bold text-[#1A1A2E] dark:text-white">
                Pengumuman Kemahasiswaan
              </h2>
              <p className="mt-1.5 text-sm text-gray-500 dark:text-gray-400">
                Informasi kegiatan, lomba, beasiswa, dan pengumuman resmi untuk mahasiswa.
              </p>
            </div>
            <Link to="/berita" className="hidden shrink-0 items-center gap-1.5 whitespace-nowrap text-sm font-medium text-[#7B2FBE] hover:underline sm:inline-flex">
              Semua berita <ArrowRight size={14} />
            </Link>
          </div>
          {loading ? (
            <div className="grid min-h-40 place-items-center text-sm text-gray-400">Memuat…</div>
          ) : announcements.length === 0 ? (
            <div className="rounded-2xl border border-dashed border-gray-200 py-12 text-center dark:border-gray-700">
              <Megaphone className="mx-auto text-gray-300 dark:text-gray-600" size={36} />
              <p className="mt-3 text-sm text-gray-500 dark:text-gray-400">
                Belum ada pengumuman dari Unit Kemahasiswaan &amp; Alumni.
              </p>
            </div>
          ) : (
            <div className="grid gap-5 lg:grid-cols-2">
              {announcements.map((item) => <AnnouncementCard key={item.id} item={item} />)}
            </div>
          )}
        </div>
      </section>

      {/* CTA */}
      <section className="py-16">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#4C1D95] via-[#7B2FBE] to-[#9333EA] p-7 text-white shadow-xl shadow-purple-900/10 sm:p-10"
          >
            <div className="absolute -right-16 -top-20 h-64 w-64 rounded-full bg-white/10" />
            <div className="absolute -bottom-24 right-32 h-48 w-48 rounded-full bg-white/5" />
            <div className="relative z-10 flex flex-col gap-7 md:flex-row md:items-center md:justify-between">
              <div className="max-w-3xl">
                <div className="flex items-center gap-2 text-sm font-semibold text-purple-100">
                  <GraduationCap size={19} /> Layanan Mahasiswa &amp; Alumni
                </div>
                <h2 className="mt-3 font-heading text-2xl font-bold sm:text-3xl">
                  Butuh bantuan kegiatan kemahasiswaan atau ingin terhubung sebagai alumni?
                </h2>
                <p className="mt-3 leading-relaxed text-purple-100">
                  Hubungi Unit Kemahasiswaan &amp; Alumni STIKES Harapan Ibu Jambi untuk layanan organisasi
                  mahasiswa, perizinan kegiatan, bimbingan prestasi, hingga informasi Ikatan Alumni.
                </p>
                {announcements.length === 0 && (
                  <p className="mt-3 inline-flex items-center gap-1.5 text-sm text-purple-100">
                    <Newspaper size={15} />
                    Info kegiatan &amp; pengumuman terbaru tersedia di
                    <Link to="/berita" className="font-semibold text-white underline underline-offset-2">
                      Berita &amp; Pengumuman
                    </Link>
                  </p>
                )}
              </div>
              <Link
                to="/kontak"
                className="inline-flex shrink-0 items-center justify-center gap-2 rounded-xl bg-white px-5 py-3 text-sm font-bold text-[#6D28A8] shadow-lg transition hover:-translate-y-0.5 hover:bg-purple-50"
              >
                Hubungi Unit <ArrowRight size={16} />
              </Link>
              <Link
                to="/prestasi-mahasiswa"
                className="inline-flex shrink-0 items-center justify-center gap-2 rounded-xl border border-white/30 px-5 py-3 text-sm font-bold text-white transition hover:-translate-y-0.5 hover:bg-white/10"
              >
                Lihat Prestasi <Trophy size={16} />
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Menu layanan eksternal Simbelmawa */}
      <section className="border-t border-purple-100 bg-white py-16 dark:border-purple-900/30 dark:bg-[#100E1C]">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
          <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#7B2FBE] dark:text-purple-300">
                Portal Resmi
              </span>
              <h2 className="mt-3 font-heading text-2xl font-bold text-[#1A1A2E] dark:text-white sm:text-3xl">
                Layanan Program Kemahasiswaan
              </h2>
              <p className="mt-2 max-w-2xl text-sm leading-relaxed text-gray-500 dark:text-gray-400">
                Akses informasi dan layanan program kemahasiswaan melalui portal Simbelmawa Kemdiktisaintek.
              </p>
            </div>
            <a
              href={SIMBELMAWA_PORTAL_URL}
              target="_blank"
              rel="noreferrer"
              className="inline-flex shrink-0 items-center justify-center gap-2 rounded-xl bg-[#7B2FBE] px-4 py-3 text-sm font-semibold text-white shadow-lg shadow-purple-500/20 transition hover:-translate-y-0.5 hover:bg-[#6924a7]"
            >
              Buka Portal Simbelmawa <ExternalLink size={15} />
            </a>
          </div>

          <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
            {simbelmawaPrograms.map(({ title, description, icon: Icon, url }, index) => (
              <motion.a
                key={title}
                href={url}
                target="_blank"
                rel="noreferrer"
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.35, delay: index * 0.03 }}
                className="group flex items-center gap-3 rounded-2xl border border-gray-100 bg-[#F8F7FF] p-4 transition hover:-translate-y-0.5 hover:border-purple-200 hover:bg-purple-50 hover:shadow-md dark:border-gray-800 dark:bg-[#1A182E] dark:hover:border-purple-800 dark:hover:bg-purple-900/20"
              >
                <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-purple-100 text-[#7B2FBE] transition group-hover:bg-[#7B2FBE] group-hover:text-white dark:bg-purple-900/30 dark:text-purple-300">
                  <Icon size={19} />
                </span>
                <span className="min-w-0">
                  <span className="block font-heading text-sm font-bold text-[#1A1A2E] dark:text-white">{title}</span>
                  <span className="mt-0.5 block text-[11px] leading-snug text-gray-500 dark:text-gray-400">{description}</span>
                </span>
                <ExternalLink className="ml-auto shrink-0 text-gray-300 transition group-hover:text-[#7B2FBE] dark:text-gray-600" size={14} />
              </motion.a>
            ))}
          </div>
        </div>
      </section>
      {/* Pengumuman unit ditempatkan setelah Portal Resmi agar tersedia ruang berita yang lebih luas. */}
      <section className="border-t border-purple-100 bg-[#F8F7FF] py-16 dark:border-purple-900/30 dark:bg-[#121020]">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
          <div className="mb-6 flex items-end justify-between gap-4">
            <div>
              <h2 className="font-heading text-2xl font-bold text-[#1A1A2E] dark:text-white">Pengumuman Kemahasiswaan</h2>
              <p className="mt-1.5 text-sm text-gray-500 dark:text-gray-400">
                Informasi kegiatan, lomba, beasiswa, dan pengumuman resmi untuk mahasiswa.
              </p>
            </div>
            <Link to="/berita" className="hidden shrink-0 items-center gap-1.5 whitespace-nowrap text-sm font-medium text-[#7B2FBE] hover:underline sm:inline-flex">
              Semua berita <ArrowRight size={14} />
            </Link>
          </div>
          {loading ? (
            <div className="grid min-h-40 place-items-center text-sm text-gray-400">Memuatâ€¦</div>
          ) : announcements.length === 0 ? (
            <div className="rounded-2xl border border-dashed border-gray-200 py-12 text-center dark:border-gray-700">
              <Megaphone className="mx-auto text-gray-300 dark:text-gray-600" size={36} />
              <p className="mt-3 text-sm text-gray-500 dark:text-gray-400">Belum ada pengumuman dari Unit Kemahasiswaan &amp; Alumni.</p>
            </div>
          ) : (
            <>
              <div className="grid gap-5 lg:grid-cols-2">
                {pageAnnouncements.map((item) => <AnnouncementCard key={item.id} item={item} />)}
              </div>
              {announcementTotalPages > 1 && (
                <nav aria-label="Navigasi pengumuman" className="mt-8 flex items-center justify-center gap-3">
                  <button
                    type="button"
                    onClick={() => setAnnouncementPage((page) => Math.max(1, page - 1))}
                    disabled={currentAnnouncementPage === 1}
                    className="inline-flex items-center gap-1.5 rounded-xl border border-gray-200 bg-white px-4 py-2 text-xs font-semibold text-gray-600 transition hover:border-purple-200 hover:text-[#7B2FBE] disabled:cursor-not-allowed disabled:opacity-40 dark:border-gray-700 dark:bg-[#1A182E] dark:text-gray-300"
                  >
                    <ChevronLeft size={14} /> Sebelumnya
                  </button>
                  <span className="text-xs font-semibold text-gray-500 dark:text-gray-400">Halaman {currentAnnouncementPage} dari {announcementTotalPages}</span>
                  <button
                    type="button"
                    onClick={() => setAnnouncementPage((page) => Math.min(announcementTotalPages, page + 1))}
                    disabled={currentAnnouncementPage === announcementTotalPages}
                    className="inline-flex items-center gap-1.5 rounded-xl border border-gray-200 bg-white px-4 py-2 text-xs font-semibold text-gray-600 transition hover:border-purple-200 hover:text-[#7B2FBE] disabled:cursor-not-allowed disabled:opacity-40 dark:border-gray-700 dark:bg-[#1A182E] dark:text-gray-300"
                  >
                    Berikutnya <ChevronRight size={14} />
                  </button>
                </nav>
              )}
            </>
          )}
        </div>
      </section>
    </main>
  </div>
  );
};

export default Kemahasiswaan;
